import { AppRoutes } from "@/routes/AppRoutes";

import { Providers } from "./Providers";

/** Raíz de la aplicación: monta los providers globales y la tabla de rutas. */
export function App() {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
